import { render, staticRenderFns } from "./RoomIcon.vue?vue&type=template&id=617e2925&"
import script from "./RoomIcon.vue?vue&type=script&lang=js&"
export * from "./RoomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports